import {TriangleDownIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu, Stack} from '@primer/react'

import styles from '../../GlobalSSOBanner.module.css'
import {DISMISSAL_DURATION_OPTIONS} from './constants'

export interface DurationMenuProps {
  selectedDurationIndex: number
  onDurationChange: (index: number) => void
}

export function DurationMenu({selectedDurationIndex, onDurationChange}: DurationMenuProps) {
  const selectedDuration = DISMISSAL_DURATION_OPTIONS[selectedDurationIndex]

  return (
    <Stack align="center" direction="horizontal" className={styles.durationSelector}>
      <span id="dismissal-duration-label">Remind me again in</span>
      <ActionMenu>
        <ActionMenu.Button trailingAction={TriangleDownIcon} aria-labelledby="dismissal-duration-label">
          {selectedDuration?.text || 'Pick duration'}
        </ActionMenu.Button>
        <ActionMenu.Overlay>
          <ActionList selectionVariant="single" role="menu" aria-labelledby="dismissal-duration-label">
            {DISMISSAL_DURATION_OPTIONS.map((option, index) => (
              <ActionList.Item
                key={option.id}
                role="menuitemradio"
                selected={index === selectedDurationIndex}
                aria-checked={index === selectedDurationIndex}
                onSelect={() => onDurationChange(index)}
              >
                {option.text}
              </ActionList.Item>
            ))}
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </Stack>
  )
}
